import { ReactNode } from 'react';
import HeaderBanner from '@framework/ui/Organisms/HeaderBanner';
import Header from '@/creditflowresearch/ui/common/components/organisms/Header';
import Footer from '@/creditflowresearch/ui/common/components/Footer';
import { CONTENT_WRAPPER_ID } from '@/creditflowresearch/ui/common/components/Layout/constants';

import styles from './layoutTemplate.module.scss';

interface ILayoutTemplateProps {
  BannerComponent?: ReactNode,
  HeaderComponent?: ReactNode,
  children?: ReactNode,
  FooterComponent?: ReactNode,
}

const LayoutTemplate = ({
  BannerComponent = <HeaderBanner isSticky={ false } />,
  HeaderComponent = <Header />,
  children,
  FooterComponent = <Footer />,
}: ILayoutTemplateProps) => (
  <>
    <div className={ styles.pageContainerWithStickyFooter }>
      <div className={ styles.topSticky }>
        { BannerComponent }
        { HeaderComponent }
      </div>
      <div className={ styles.layoutChildrenContainer } id={ CONTENT_WRAPPER_ID }>
        { children }
      </div>
    </div>
    { FooterComponent }
  </>
);

export default LayoutTemplate;
